import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    isLoading: false,
    dau: {
        pcNum: 0,
        mobileNum: 0,
    },
};

const [
    viewModel,
    update, reset,
] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};

export default viewModel;
